import { useState, useEffect, useRef } from 'react';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { Observer } from "gsap/Observer";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { MorphSVGPlugin } from "gsap/MorphSVGPlugin";
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin";
import { SplitText } from "gsap/SplitText";
import { Draggable } from 'gsap/Draggable'; 
import { InertiaPlugin } from "gsap/InertiaPlugin";

import { useGSAP } from '@gsap/react';

// import { scrollResizeControlJess } from './utils/scroll-resize-jess';
// import { scrollResizeControlTest } from './utils/scroll-resize-test';
// import { smoother, observer, scrollResizeControlMake } from './utils/scroll-resize';

import { csLog, calScrollbarWidth, waitForFinalEvent } from './utils/utils';

import { appData, pageInitState } from './utils/config';
import { controlKeyHandler } from './utils/control-keys';

import Router from './routes/Router';

// import TestLayout from './pages/TestLayout'
import Loading from './pages/Loading';
// import Home from './pages/Home';
// import HomeChange from './pages/HomeChange';
// import Web from './pages/Web';

import Menu from './pages/Menu';
import Header from './pages/Header'
import Resizing from './components/Resizing';
import Cursor from './pages/Cursor';

gsap.registerPlugin(useGSAP, ScrollTrigger, ScrollSmoother, ScrollToPlugin, MotionPathPlugin, MorphSVGPlugin, ScrambleTextPlugin, SplitText, Draggable, InertiaPlugin);


////////// jess: Dev, comment for production [START]
window.gsapRef = gsap; // jess: Dev
window.scrollTriggerRef = ScrollTrigger; // jess: Dev
window.scrollSmootherRef = ScrollSmoother; // jess: Dev
window.splitTextRef = SplitText; // jess: Dev
window.draggableRef = Draggable;
window.inertiaPluginRef = InertiaPlugin;
////////// jess: Dev, comment for production [END]


function App () {
  const appLoadedTimeoutRef = useRef(null);
  const [appLoaded, setAppLoaded] = useState(false);
  const [loadingOn, setLoadingOn] = useState(true);

  // const [pageCurrent, setPageCurrent] = useState(page);
  const [pageCurrent, setPageCurrent] = useState("");
  const [pageChangeOn, setPageChangeOn] = useState({...pageInitState});
  const [pageOn, setPageOn] = useState({...pageInitState});

  const [cursorOn, setCursorOn] = useState(false);
  const [menuOn, setMenuOn] = useState(false);

  const appResizing = useRef(false);
  const [resizingOn, setResizingOn] = useState(false);

  // const onPopstate = (e) => {
  //   console.log('APP: popstate');
  //   e.preventDefault();
  //   return false;
  // }

  useEffect(() => {
    console.log('APP: useEffect: [] ==============================');

    let onAppResizeHandler = e => {
      
      if(!appResizing.current) {
        console.log('APP: Resize: START');

        appData.isResizing = true;

        appResizing.current = true;
        setResizingOn(true); // jess: dev, don't set it true
      }

      waitForFinalEvent( function() {
        console.log('APP: Resize: END');

        appData.isResizing = false;

        appResizing.current = false;
        setResizingOn(false);

        ScrollTrigger.refresh();

      }, 5000, 'onAppResizeHandler'); // call resize handler a bit later than each page
    }

    window.addEventListener('resize', onAppResizeHandler);

    ////////// jess: test ScrollTriger Refresh event handler
    // const onScrollTriggerRefresh =  (e) => {
    //   console.log("GSAP has finished resizing and recalculating layouts!", e);
    // }
    // ScrollTrigger.addEventListener("refresh", onScrollTriggerRefresh);
    
    return () => {
      console.log('APP: useEffect: [] ============================== : cleanup');

      window.removeEventListener('resize', onAppResizeHandler);

      ////////// jess: test ScrollTriger Refresh event handler
      // ScrollTrigger.removeEventListener("refresh", onScrollTriggerRefresh);
    }
  }, []);

  useGSAP((context, contextSafe) => {
    console.log(`APP: useGSAP: [] ==============================`);

    ////////// Load event listener: Add
    const onAppLoaded = () => {
      csLog(`App: onAppLoaded, appLoaded: (${appLoaded})`);

      clearTimeout(appLoadedTimeoutRef.current);

      appLoadedTimeoutRef.current = setTimeout(() => {
        // window.scroll(0, 0);  // Not used // call it a bit after browser's default scrolling down        
        
        // scrollResizeControlJess(gsap, 'home'); // Not Used
        // scrollResizeControlTest(gsap, ScrollTrigger, Observer, ScrollSmoother, 'home'); // Not Used

        ////////// jess: 20260807: do this on each page when the page is ready
        // scrollResizeControlMake(gsap, ScrollTrigger, Observer, ScrollSmoother, pageCurrent);
        // smoother.scrollTop(0); // jess: Dev: Don't make it to top
        // smoother.paused(true);
        
        calScrollbarWidth();

        setAppLoaded(true); // jess: Dev: Comment to keep loading on

        csLog(`App: setTimeout, appLoaded: (${true}), appLoadedTimeoutRef.current executed`, appLoadedTimeoutRef.current);
      }, 100);

      csLog(`App: onAppLoaded, appLoaded: (${appLoaded}), appLoadedTimeoutRef.current set`, appLoadedTimeoutRef.current);
    }

    ////////// popstate event listener: Add
    // window.addEventListener('popstate', onPopstate);

    ////////// Load event listener: Add
    if(document.readyState === 'complete') onAppLoaded()
    else window.addEventListener('load', onAppLoaded, false);

    ////////// Set a scrollbar width: Add
    window.addEventListener('load', calScrollbarWidth); // recalculate on load (assets loaded as well)
    document.addEventListener('DOMContentLoaded', calScrollbarWidth, false); // recalculate on dom load
    window.addEventListener('resize', calScrollbarWidth, false); // recalculate on resize

    ////////// Control Keys Event Listener: Add
    const controlKeysRef = contextSafe(controlKeyHandler)
    window.addEventListener('keydown', controlKeysRef);


    return () => {
      console.log('APP: useGSAP: [] ============================== : cleanup');

      ////////// popstate event listener: Remove
      // window.removeEventListener('popstate', onPopstate);

      ////////// Load event listener: Remove
      window.removeEventListener('load', onAppLoaded, false);

      ////////// Set a scrollbar width: Remove
      window.removeEventListener('load', calScrollbarWidth); // recalculate on load (assets loaded as well)
      document.removeEventListener('DOMContentLoaded', calScrollbarWidth, false); // recalculate on dom load
      window.removeEventListener('resize', calScrollbarWidth, false); // recalculate on resize

      ////////// Cntrol keys event listener: Remove
      window.removeEventListener('keydown', controlKeysRef);
    }
  });

  return (
    <>
      {/* <TestLayout /> */}
      {loadingOn && <Loading appLoaded={appLoaded} setLoadingOn={setLoadingOn} pageCurrent={pageCurrent} setPageChangeOn={setPageChangeOn}  setPageOn={setPageOn}/>}
      <Router
        appLoaded={appLoaded}
        loadingOn={loadingOn}
        pageCurrent={pageCurrent}
        setPageCurrent={setPageCurrent}
        pageChangeOn={pageChangeOn}
        setPageChangeOn={setPageChangeOn}
        pageOn={pageOn}
        setPageOn={setPageOn}
        setCursorOn={setCursorOn} 
      />
      <Menu menuOn={menuOn} setMenuOn={setMenuOn} pageCurrent={pageCurrent} />
      <Header menuOn={menuOn} setMenuOn={setMenuOn}/>
      <Cursor cursorOn={cursorOn} />
      <Resizing resizingOn={resizingOn} pageCurrent={pageCurrent} />
    </>
  )
}

export default App;